module.exports = __webpack_public_path__ + "static/media/source_publication.1c8c68ee.svg";